import { ResolverTag } from '@ps/web-core-enums';
import { useResolver } from '@ps/web-shared-components';
import React from 'react';

import type { MpcChest } from '@swf/core/types/ChestInventory';
import { ChestLockedType } from '@swf/core/types/Notification';

import styles from './Grid.scss';
import IceLockedChest from './components/IceLockedChest/IceLockedChest';
import RegularChest from './components/RegularChest/RegularChest';

interface Props {
  chests: MpcChest[];
}

const Grid: React.FC<Props> = ({ chests }) => {
  const starsCrmCdnBaseUrl = useResolver(ResolverTag.StarsCrmCdnBaseUrl);

  return (
    <div className={styles.mpcGrid}>
      {chests
        .filter((item) => item.isAvailable || item.lockType !== ChestLockedType.IceLocked)
        .map((item, key) => (
          <RegularChest key={`chest-${key}`} {...item} starsCrmCdnBaseUrl={starsCrmCdnBaseUrl} />
        ))}
      {chests
        .filter((item) => !item.isAvailable && item.lockType === ChestLockedType.IceLocked)
        .map((item: MpcChest, key) => (
          <IceLockedChest
            key={`ice-chest-${key}`}
            {...item}
            starsCrmCdnBaseUrl={starsCrmCdnBaseUrl}
          />
        ))}
    </div>
  );
};

export default Grid;
